import { GlobalUtilityHeaderComponent } from './global-utility-header/global-utility-header.component';

export const containers: any = [GlobalUtilityHeaderComponent];

export * from './global-utility-header/global-utility-header.component';
